module.exports = __webpack_public_path__ + "static/media/menu.77291a97.svg";